<template>
  <div
    class="email-textarea-container"
    :class="{
      'input-error': error,
    }"
    @click="setFocus"
  >
    <EmailTicket
      v-for="(elem, idx) in items"
      :key="idx"
      :email="elem.name"
      class="email-textarea-ticket"
      @remove-email="removeItem(idx)"
    />
    <input
      ref="emailInput"
      v-model="emailInput"
      :placeholder="placeholderText"
      type="text"
      :required="required && !items.length"
      class="email-textarea-input"
      @paste="handlePaste"
      @keypress="isValid($event)"
    />
  </div>
</template>

<script>
  import EmailTicket from '@/components/ui/EmailTicket';
  import inputErrors from '@/utils/mixins/input-errors';

  export default {
    name: 'TagsTextarea',
    components: { EmailTicket },
    mixins: [inputErrors],
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      placeholder: {
        type: String,
        default: '',
      },
      required: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        emailInput: '',
      };
    },
    computed: {
      placeholderText() {
        return this.items.length ? '' : this.placeholder;
      },
    },
    methods: {
      removeItem(idx) {
        this.items.splice(idx, 1);
        this.$emit('update-items', this.items);
      },
      addItem(value) {
        this.$emit('update-items', [...this.items, { name: value }]);
      },
      addEmails(emails) {
        let newEmails = [];
        emails.split(/,| /).forEach((email) => {
          newEmails = [...newEmails, { name: email }];
        });
        this.$emit('update-items', [...this.items, ...newEmails]);
      },
      isValid(evt) {
        evt = evt ? evt : window.event;
        const charCode = evt.which ? evt.which : evt.keyCode;
        // Comma
        if (charCode === 44) {
          evt.preventDefault();
          this.addItem(this.emailInput);
          this.emailInput = '';
        } else {
          return true;
        }
      },
      setFocus() {
        this.$refs.emailInput.focus();
      },
      handlePaste(evt) {
        this.addEmails(evt.clipboardData.getData('text'));
        evt.preventDefault();
      },
    },
  };
</script>
<style lang="scss">
  @import 'src/styles/components/email-textarea';

  .email-textarea-container {
    min-height: 48px;
    align-content: center;
  }
</style>
